export enum EventEverFlowType {
    Sale,
    Event1,
    Event2,
    Event3,
    Event4,
    Event14 = 14,
    Event15 = 15,
    Event16 = 16
}